'use client';

import React, { createContext, type ReactNode, useContext, useMemo } from 'react';
import { Api } from '../services/generated/Api';
import { getApiBaseUrl } from '../utils/apiBaseUrl';

export class ApiClient extends Api<unknown> {
  constructor(baseUrl: string = getApiBaseUrl()) {
    super({
      baseUrl,
      baseApiParams: {
        credentials: 'include',
        headers: { 'X-Requested-With': 'shot' },
      },
    });
  }
}

export const ApiContext = createContext<Api<unknown> | null>(null);

interface ApiProviderProps {
  children: ReactNode;
  apiClient?: Api<unknown>;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({ children, apiClient }) => {
  const value = useMemo(() => apiClient ?? new ApiClient(), [apiClient]);
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};

export const useApiClient = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApiClient must be used within an ApiProvider');
  }
  return context;
};
